import React from 'react';
import { motion } from 'framer-motion';
import { usePageMeta } from '../hooks/usePageMeta';
import { Section } from '../components/ui/Section';
import { useIsKenya, getPhoneDisplay } from '../hooks/useIsKenya';
function HeroArtwork() {
  return <motion.svg viewBox="0 0 400 300" className="w-full h-full max-h-[280px]" initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.8,
    delay: 0.2
  }} data-id="element-818">
      {/* Large circle - stroke only */}
      <circle cx="200" cy="150" r="120" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.12" data-id="element-819" />
      <circle cx="200" cy="150" r="80" fill="none" stroke="#00316B" strokeWidth="0.5" opacity="0.1" data-id="element-820" />
      <circle cx="200" cy="150" r="40" fill="#00316B" opacity="0.04" data-id="element-821" />

      {/* Arc segments */}
      <path d="M 80 150 A 120 120 0 0 1 200 30" fill="none" stroke="#00316B" strokeWidth="2" opacity="0.15" data-id="element-822" />
      <path d="M 320 150 A 120 120 0 0 1 200 270" fill="none" stroke="#00316B" strokeWidth="2" opacity="0.15" data-id="element-823" />

      {/* Grid lines */}
      <line x1="50" y1="150" x2="350" y2="150" stroke="#00316B" strokeWidth="0.5" opacity="0.08" data-id="element-824" />
      <line x1="200" y1="20" x2="200" y2="280" stroke="#00316B" strokeWidth="0.5" opacity="0.08" data-id="element-825" />

      {/* Diagonal lines */}
      <line x1="80" y1="50" x2="320" y2="250" stroke="#00316B" strokeWidth="0.5" opacity="0.06" data-id="element-826" />
      <line x1="320" y1="50" x2="80" y2="250" stroke="#00316B" strokeWidth="0.5" opacity="0.06" data-id="element-827" />

      {/* Scattered dots */}
      <circle cx="120" cy="80" r="3" fill="#00316B" opacity="0.18" data-id="element-828" />
      <circle cx="280" cy="220" r="3" fill="#00316B" opacity="0.18" data-id="element-829" />
      <circle cx="300" cy="80" r="2" fill="#00316B" opacity="0.12" data-id="element-830" />
      <circle cx="100" cy="200" r="2" fill="#00316B" opacity="0.12" data-id="element-831" />
      <circle cx="200" cy="150" r="4" fill="#00316B" opacity="0.2" data-id="element-832" />

      {/* Small accent circles */}
      <circle cx="140" cy="120" r="15" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-833" />
      <circle cx="260" cy="180" r="15" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-834" />

      {/* Orange accent - subtle */}
      <circle cx="240" cy="100" r="6" fill="#FF6600" opacity="0.12" data-id="element-835" />
    </motion.svg>;
}
function SidebarArtwork() {
  return <motion.svg viewBox="0 0 100 500" className="w-full h-auto" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.6,
    delay: 0.4
  }} data-id="element-836">
      {/* Vertical line */}
      <line x1="50" y1="0" x2="50" y2="500" stroke="#00316B" strokeWidth="0.5" opacity="0.08" data-id="element-837" />

      {/* Stacked circles */}
      <circle cx="50" cy="60" r="40" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-838" />
      <circle cx="50" cy="60" r="25" fill="none" stroke="#00316B" strokeWidth="0.5" opacity="0.08" data-id="element-839" />
      <circle cx="50" cy="60" r="4" fill="#00316B" opacity="0.15" data-id="element-840" />

      <circle cx="50" cy="180" r="30" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-841" />
      <circle cx="50" cy="180" r="15" fill="#00316B" opacity="0.04" data-id="element-842" />

      <circle cx="50" cy="280" r="35" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-843" />
      <circle cx="50" cy="280" r="20" fill="none" stroke="#00316B" strokeWidth="0.5" opacity="0.08" data-id="element-844" />

      <circle cx="50" cy="380" r="25" fill="none" stroke="#00316B" strokeWidth="1" opacity="0.1" data-id="element-845" />
      <circle cx="50" cy="380" r="3" fill="#00316B" opacity="0.15" data-id="element-846" />

      {/* Horizontal accent lines */}
      <line x1="20" y1="120" x2="80" y2="120" stroke="#00316B" strokeWidth="0.5" opacity="0.1" data-id="element-847" />
      <line x1="30" y1="230" x2="70" y2="230" stroke="#00316B" strokeWidth="0.5" opacity="0.1" data-id="element-848" />
      <line x1="25" y1="330" x2="75" y2="330" stroke="#00316B" strokeWidth="0.5" opacity="0.1" data-id="element-849" />

      {/* Small dots */}
      <circle cx="30" cy="140" r="2" fill="#00316B" opacity="0.12" data-id="element-850" />
      <circle cx="70" cy="260" r="2" fill="#00316B" opacity="0.12" data-id="element-851" />
      <circle cx="35" cy="350" r="2" fill="#00316B" opacity="0.12" data-id="element-852" />

      {/* Orange accent */}
      <circle cx="50" cy="450" r="20" fill="none" stroke="#FF6600" strokeWidth="1" opacity="0.1" data-id="element-853" />
      <circle cx="50" cy="450" r="3" fill="#FF6600" opacity="0.15" data-id="element-854" />
    </motion.svg>;
}
export function PrivacyPage() {
  usePageMeta({
    title: 'Privacy Policy',
    description: 'Learn how Belo Digital collects, uses, and protects your personal information.'
  });
  const isKenya = useIsKenya();
  const phoneDisplay = getPhoneDisplay(isKenya);
  const sections = [{
    number: '1',
    title: 'Overview',
    content: <p data-id="element-855">
          Belo Digital is committed to protecting personal data and privacy.
          This policy explains how we collect, use, and safeguard information.
        </p>
  }, {
    number: '2',
    title: 'Information We Collect',
    content: <>
          <p className="mb-6" data-id="element-856">We may collect:</p>
          <div className="space-y-6" data-id="element-857">
            <div data-id="element-858">
              <h4 className="font-semibold text-[#0C0C0C] mb-3" data-id="element-859">
                a) Personal Information
              </h4>
              <ul className="space-y-3" data-id="element-860">
                {['Names', 'Email addresses', 'Phone numbers', 'Company details', 'Job or professional information'].map(item => <li key={item} className="flex items-start text-lg" data-id="element-861">
                    <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2.5 mr-3 shrink-0" data-id="element-862" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div data-id="element-863">
              <h4 className="font-semibold text-[#0C0C0C] mb-3" data-id="element-864">
                b) Technical Information
              </h4>
              <ul className="space-y-3" data-id="element-865">
                {['IP addresses', 'Browser/device data', 'Usage analytics'].map(item => <li key={item} className="flex items-start text-lg" data-id="element-866">
                      <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2.5 mr-3 shrink-0" data-id="element-867" />
                      {item}
                    </li>)}
              </ul>
            </div>
            <div data-id="element-868">
              <h4 className="font-semibold text-[#0C0C0C] mb-3" data-id="element-869">
                c) Client & Business Data
              </h4>
              <p data-id="element-870">Where relevant to services delivered under contract.</p>
            </div>
          </div>
        </>
  }, {
    number: '3',
    title: 'How We Use Information',
    content: <>
          <p className="mb-4" data-id="element-871">We use data to:</p>
          <ul className="space-y-3" data-id="element-872">
            {['Deliver and improve services', 'Communicate with clients & partners', 'Provide technical support', 'Meet legal or regulatory obligations', 'Enhance security and performance'].map(item => <li key={item} className="flex items-start text-lg" data-id="element-873">
                <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2.5 mr-3 shrink-0" data-id="element-874" />
                {item}
              </li>)}
          </ul>
        </>
  }, {
    number: '4',
    title: 'Data Protection & Security',
    content: <>
          <p className="mb-4" data-id="element-875">
            We implement reasonable technical and organizational safeguards to
            protect data against:
          </p>
          <ul className="space-y-3" data-id="element-876">
            {['Unauthorized access', 'Loss or misuse', 'Alteration or disclosure'].map(item => <li key={item} className="flex items-start text-lg" data-id="element-877">
                <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2.5 mr-3 shrink-0" data-id="element-878" />
                {item}
              </li>)}
          </ul>
        </>
  }, {
    number: '5',
    title: 'Data Sharing',
    content: <>
          <p className="mb-4" data-id="element-879">
            We do not sell personal data. Information may only be shared:
          </p>
          <ul className="space-y-3" data-id="element-880">
            {['With authorized service providers', 'Where legally required', 'Under contractual obligations'].map(item => <li key={item} className="flex items-start text-lg" data-id="element-881">
                <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2.5 mr-3 shrink-0" data-id="element-882" />
                {item}
              </li>)}
          </ul>
        </>
  }, {
    number: '6',
    title: 'Data Retention',
    content: <p data-id="element-883">
          We retain data only as long as necessary for legitimate business,
          contractual, or legal purposes.
        </p>
  }, {
    number: '7',
    title: 'User Rights',
    content: <>
          <p className="mb-4" data-id="element-884">
            Subject to applicable law, individuals may request:
          </p>
          <ul className="space-y-3" data-id="element-885">
            {['Access to their data', 'Correction of inaccuracies', 'Deletion where appropriate', 'Withdrawal of consent (where applicable)'].map(item => <li key={item} className="flex items-start text-lg" data-id="element-886">
                <span className="w-2 h-2 rounded-full bg-[#00316B] mt-2.5 mr-3 shrink-0" data-id="element-887" />
                {item}
              </li>)}
          </ul>
        </>
  }, {
    number: '8',
    title: 'Cookies & Tracking',
    content: <p data-id="element-888">
          Our website may use cookies or analytics tools to improve user
          experience and performance.
        </p>
  }, {
    number: '9',
    title: 'Third-Party Links',
    content: <p data-id="element-889">
          Our website may contain external links. We are not responsible for
          third-party privacy practices.
        </p>
  }, {
    number: '10',
    title: 'Policy Updates',
    content: <p data-id="element-890">
          We may revise this Privacy Policy periodically. Updates will be
          reflected with a new effective date.
        </p>
  }, {
    number: '11',
    title: 'Contact Information',
    content: <div className="space-y-2" data-id="element-891">
          <p data-id="element-892">For privacy-related inquiries:</p>
          <p className="font-semibold text-[#0C0C0C]" data-id="element-893">Belo Digital</p>
          <p data-id="element-894">
            Email:{' '}
            <a href="mailto:biz@belo.co.ke" className="text-[#00316B] hover:text-[#FF6600] transition-colors" data-id="element-895">
              biz@belo.co.ke
            </a>
          </p>
          <p data-id="element-896">
            Phone:{' '}
            <a href="tel:+254701660306" className="text-[#00316B] hover:text-[#FF6600] transition-colors" data-id="element-897">
              {phoneDisplay}
            </a>
          </p>
        </div>
  }];
  return <main className="pt-24" data-id="element-898">
      <Section background="default" data-id="element-899">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-900">
          <div data-id="element-901">
            <motion.p initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-sm font-semibold text-[#00316B] uppercase tracking-wider mb-4" data-id="element-902">
              Legal
            </motion.p>
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.05
          }} className="text-4xl md:text-5xl font-bold font-heading text-[#0C0C0C] mb-4 leading-tight" data-id="element-903">
              Privacy Policy
            </motion.h1>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="text-gray-500 text-base" data-id="element-904">
              Last updated:{' '}
              {new Date().toLocaleDateString('en-GB', {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            })}
            </motion.p>
          </div>
          <div className="hidden lg:flex items-center justify-center" data-id="element-905">
            <HeroArtwork data-id="element-906" />
          </div>
        </div>
      </Section>

      <Section background="white" data-id="element-907">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-908">
          {/* Main content */}
          <div className="lg:col-span-9" data-id="element-909">
            <div className="space-y-14" data-id="element-910">
              {sections.map((section, index) => <motion.div key={section.number} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.04
            }} className="border-b border-gray-100 pb-14 last:border-0" data-id="element-911">
                  <div className="flex items-start gap-4 mb-5" data-id="element-912">
                    <span className="text-sm font-bold text-[#00316B] bg-[#00316B]/10 px-3 py-1.5 rounded mt-0.5 shrink-0" data-id="element-913">
                      {section.number.padStart(2, '0')}
                    </span>
                    <h2 className="text-2xl font-bold font-heading text-[#0C0C0C]" data-id="element-914">
                      {section.title}
                    </h2>
                  </div>
                  <div className="ml-14 text-gray-600 leading-relaxed text-lg" data-id="element-915">
                    {section.content}
                  </div>
                </motion.div>)}
            </div>
          </div>

          {/* Decorative sidebar */}
          <div className="hidden lg:block lg:col-span-3" data-id="element-916">
            <div className="sticky top-32" data-id="element-917">
              <SidebarArtwork data-id="element-918" />
            </div>
          </div>
        </div>
      </Section>
    </main>;
}